import { DENIED, GRANTED } from '../lib/consent.js';

/**
 * The way back to the answer somebody gave the consent bar.
 *
 * It has to be reachable without an account, because the people the bar
 * interrupts are mostly not signed in — which is why this is a component and
 * not a line in one modal.
 */
export default function ConsentToggle({ consent, onChange, verbose = false, className }) {
  const on = consent === GRANTED;
  return (
    <button
      type="button"
      className={className}
      title={on ? 'Turn cookies off' : 'Turn cookies on'}
      onClick={() => onChange(on ? DENIED : GRANTED)}
    >
      {verbose
        ? (on ? 'Cookies on · turn off' : 'Cookies off · turn on')
        : (on ? 'Cookies on' : 'Cookies off')}
    </button>
  );
}
